import { FC } from 'react';
import { Button } from '@cfa/react-core';
import { themeSizes } from '../../../../styles/globalStyleVars';
import { ButtonRow } from '../../../Styled/ButtonRow';
import { callEvent } from '../../../../utils/Amplitude/AmplitudeUtilities';

interface Props {
  onClose: () => void;
  isLgAndUp: boolean;
  activeLocation: string;
  kbArticle?: string;
  setUserOnboarded: () => void;
  showWhatsNewFeatureFlag: boolean;
  featureType?: string;
}

const IntroductionModalFooter: FC<Props> = ({
  onClose,
  isLgAndUp,
  activeLocation,
  kbArticle,
  setUserOnboarded,
  showWhatsNewFeatureFlag,
  featureType,
}) => {
  const goToArticle = () => {
    setUserOnboarded();
    window.open(`/kb/${kbArticle}`, '_blank', 'noreferrer');
    callEvent('clicked see more details onboarding', {
      locationNum: activeLocation,
      'kb number': kbArticle,
    });
  };
  return (
    <div
      style={{
        display: 'grid',
        textAlign: 'center',
      }}
    >
      {!showWhatsNewFeatureFlag && !featureType && (
        <ButtonRow $customMargin={themeSizes.md}>
          {isLgAndUp && (
            <Button
              size='lg'
              onPress={onClose}
              variant='outlined'
              style={{
                marginRight: '27px',
                minWidth: '178px',
              }}
            >
              Close
            </Button>
          )}
          <Button size='lg' onPress={goToArticle} style={{ minWidth: '178px' }}>
            See More Details
          </Button>
        </ButtonRow>
      )}
    </div>
  );
};

export default IntroductionModalFooter;
